(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-powerbi", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-powerbi"] = factory(require("react"));
	else
		root["react-powerbi"] = factory(root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 